import { Link } from "react-router-dom";
import { useReveal } from "../../../../hooks/useReveal";
import styles from "./TalentsFeatures.module.css";

const features = [
  {
    title: "AI Insights",
    body: "Personalized feedback on your skills, work style and growth opportunities — refreshed as you grow.",
    meta: "Explore insights",
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    ),
  },
  {
    title: "Skill Assessment",
    body: "Showcase real ability with verified, role-specific assessments — not self-reported skill bars.",
    meta: "See assessments",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    ),
  },
  {
    title: "Smart Matching",
    body: "Get matched to jobs that actually fit your strengths, ambitions and stage — not just keywords.",
    meta: "Browse matches",
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    ),
  },
  {
    title: "Career Growth",
    body: "Always know what to learn next. Clear roadmaps that take you from where you are to where you want to be.",
    meta: "See your roadmap",
    icon: (
      <svg viewBox="0 0 24 24">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
  },
];

function FeatureCard({ title, body, meta, icon }) {
  const { ref, isVisible } = useReveal();
  return (
    <div
      ref={ref}
      className={`${styles.card} ${isVisible ? styles.visible : styles.hidden}`}
    >
      <div className={styles.icon}>{icon}</div>
      <h3>{title}</h3>
      <p>{body}</p>
      {/* <Link to="/login" className={styles.learn}>
        {meta}
      </Link> */}
    </div>
  );
}

export default function TalentsFeatures() {
  return (
    <section className={styles.section} id="features">
      <div className={styles.container}>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>Features</span>
          <h2 className={styles.h2}>Everything you need to be seen</h2>
          <p className={styles.sub}>
            Premium tools that turn raw potential into a clear, credible signal
            companies trust.
          </p>
        </div>

        <div className={styles.grid}>
          {features.map((f) => (
            <FeatureCard key={f.title} {...f} />
          ))}
        </div>
      </div>
    </section>
  );
}
